import {type NavigationGuardNext, type RouteLocationNormalized} from 'vue-router';
import {AuthenticationNs, WorkspaceNs} from '@shared/types';
import {useWorkspaceStore} from "@shared/stores/workspace.store";
import {toast} from '@shared/ms-components'

export const confirmDeleteWorkspaceResolver = async (
    to: RouteLocationNormalized,
    from: RouteLocationNormalized,
    next: NavigationGuardNext): Promise<void> => {
  const isAuthPage = window.location.href.indexOf('/auth/') > -1;
  const payload = {
    confirmationCode: to.query.ac,
    userId: to.query.un,
    workspaceId: to.query.ws
  } as WorkspaceNs.ConfirmWorkspaceActionRequest;

  const workspaceStore = useWorkspaceStore();
  workspaceStore.confirmDeleteWorkspace(payload).then(() => {
    toast.success('Workspace has been deleted!');
  }).finally(() => {
    next({name: AuthenticationNs.AuthenticationRouteEnums.Logout});
  })
};
